import React from 'react';
import Modal from '../../../Components/Modal';
import { useSyncedPreference } from '../../../Data/Preference';
import ButtonRow from '../../../Components/Button/ButtonRow';
import Button from '../../../Components/Button/Button';

const Intro = () => {
    const [isOpen, setIsOpen] = useSyncedPreference('calendar.intro', true);

    return <Modal title="Welcome to the calendar" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>

        <div className="prose leading-6 pr-4">
            <p>
                The calendar lets you efficiently plan an entire week of work in seconds.
            </p>
            <div className="pl-2 text-pretty">
                <div className="flex flex-row items-top mb-3">
                    <span className="shrink-0 pr-3">⏱️</span>
                    <span className="grow">Plan all your due jobs as efficiently as possible</span>
                </div>
                <div className="flex flex-row items-top mb-3">
                    <span className="shrink-0 pr-3">🚦</span>
                    <span className="grow">Avoid expected traffic and road closures</span>
                </div>
                <div className="flex flex-row items-top mb-3">
                    <span className="shrink-0 pr-3">💁‍♀️</span>
                    <span className="grow">Schedule customers' preferred days and times</span>
                </div>
                <div className="flex flex-row items-top mb-3">
                    <span className="shrink-0 pr-3">🚚</span>
                    <span className="grow">Organise work across multiple vehicles or workers</span>
                </div>
            </div>

            <p>
                Tips for using the calendar...
            </p>

            <div className="pl-2">
                <div className="flex flex-row items-top mb-3">
                    <span className="shrink-0 pr-3">✅</span>
                    <span className="grow">Set a duration on each job to give yourself enough time</span>
                </div>
                <div className="flex flex-row items-top mb-3">
                    <span className="shrink-0 pr-3">✅</span>
                    <span className="grow">Use 'advanced scheduling' to set preferred days or times on customer jobs</span>
                </div>
                <div className="flex flex-row items-top mb-3">
                    <span className="shrink-0 pr-3">✅</span>
                    <span className="grow">Trust the calendar, don't mix scheduling jobs individually or in rounds</span>
                </div>
                <div className="flex flex-row items-top mb-3">
                    <span className="shrink-0 pr-3">✅</span>
                    <span className="grow">Don't forget to confirm the schedule to let your customers know you're coming</span>
                </div>
            </div>
        </div>

        <ButtonRow>
            <Button theme="primary"
                icon="ThumbsUp"
                onClick={() => setIsOpen(false)}
                label="Got it"
            />
        </ButtonRow>
    </Modal>
}

export default Intro;